import { render, staticRenderFns } from "./MyMenus.vue?vue&type=template&id=7dffb2ca&scoped=true"
import script from "./MyMenus.vue?vue&type=script&lang=js"
export * from "./MyMenus.vue?vue&type=script&lang=js"
import style0 from "./MyMenus.vue?vue&type=style&index=0&id=7dffb2ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dffb2ca",
  null
  
)

export default component.exports